import type { Dispatch } from 'react'

import type { TableFiltersProps } from '~/client/src/desktop/components/TableFilters/types'
import type {
  ListAction,
  ListModel,
  ListQuery,
  ListSchema,
} from '~/client/src/shared/lists/core'
import {
  applyFacet,
  resetFilters,
  setSearch,
} from '~/client/src/shared/lists/core'

function toSourceMapByFacet(
  sourceMapByFacet: ListModel<unknown>['sourceMapByFacet'],
): TableFiltersProps['sourceMapByFacet'] {
  return Object.fromEntries(
    Object.entries(sourceMapByFacet).map(([facetKey, sourceMap]) => [
      facetKey,
      Object.fromEntries(
        Object.entries(sourceMap).map(([optionId, ids]) => [
          optionId,
          [...ids],
        ]),
      ),
    ]),
  )
}

export function toFilterProps<T>(
  model: ListModel<T>,
  query: ListQuery,
  dispatch: Dispatch<ListAction>,
  records: readonly T[],
  schema: ListSchema<T>,
): TableFiltersProps {
  return {
    facets: model.facets.map(facet => ({
      key: facet.key,
      label: facet.label,
      displayFormatter: facet.optionLabel
        ? (value: unknown) => facet.optionLabel?.(String(value)) ?? ''
        : undefined,
    })),
    sourceMapByFacet: toSourceMapByFacet(model.sourceMapByFacet),
    appliedFilters: Object.fromEntries(
      Object.entries(query.appliedFacets).map(([key, values]) => [
        key,
        new Set(values),
      ]),
    ),
    onFilterApply: (facetKey, selectedIds) => {
      dispatch(applyFacet(facetKey, selectedIds))
    },
    onResetAll: () => {
      dispatch(resetFilters())
    },
    availableRecords: records.map(record => ({ id: schema.getId(record) })),
    searchKey: query.search,
    onSearchChange: searchKey => {
      dispatch(setSearch(searchKey))
    },
  }
}
